import http from "../httpService";
import {getBaseUrl} from "../../config";


export const submitAdminServiceVoipCall = data => {
  return http.post(
    `${getBaseUrl()}/admin_service_voip_call`,
    data
  );
};
